import React, { useEffect, useMemo } from "react";

import * as S from "./styles";
import {
  Button,
  Col2Grid,
  FH,
  Input,
  Label,
  Text,
  Title,
} from "../../../main-styles";
import WhiteBox from "../../../../components/WhiteBox";
import { useNavigate, useParams } from "react-router";
import {
  createUser,
  getAllUsers,
  getGestores,
  getUserById,
  updateUser,
} from "../../../../api/user";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faCheckCircle,
  faCircle,
} from "@fortawesome/pro-light-svg-icons";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import BackButton from "../../../../components/BackButton";
import Select from "react-select";

// === HELPERS ===

function formatPhone(raw) {
  const digits = raw.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

function unformatPhone(formatted) {
  return (formatted || "").replace(/\D/g, "");
}

function formatCNPJ(raw) {
  const digits = raw.replace(/\D/g, "").slice(0, 14);
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length <= 8) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  if (digits.length <= 12) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}

function unformatCNPJ(formatted) {
  return (formatted || "").replace(/\D/g, "");
}

function ucwords(str) {
  return str
    .split(" ")
    .map((w) => {
      if (w.length === 0) return w;
      // preposições em minúsculo
      const lower = w.toLowerCase();
      if (["de", "da", "do", "dos", "das", "e"].includes(lower) && str.indexOf(w) > 0) {
        return lower;
      }
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    })
    .join(" ");
}

function validateCNPJ(cnpj) {
  const digits = cnpj.replace(/\D/g, "");
  if (digits.length !== 14) return false;
  if (/^(\d)\1+$/.test(digits)) return false;
  let sum = 0;
  let weight = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  for (let i = 0; i < 12; i++) sum += parseInt(digits[i]) * weight[i];
  let mod = sum % 11;
  let d1 = mod < 2 ? 0 : 11 - mod;
  if (parseInt(digits[12]) !== d1) return false;
  sum = 0;
  weight = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  for (let i = 0; i < 13; i++) sum += parseInt(digits[i]) * weight[i];
  mod = sum % 11;
  let d2 = mod < 2 ? 0 : 11 - mod;
  if (parseInt(digits[13]) !== d2) return false;
  return true;
}

// === COMPONENT ===

function Novo() {
  const navigate = useNavigate();
  const { authReducer } = useSelector((state) => state);
  const [gestores, setGestores] = React.useState([]);
  const { roles: adminRoles } = authReducer.user;
  const { id } = useParams();
  const isAdmin = adminRoles.includes("admin");
  window.document.title = id
    ? "Organnact - Admin - Editar Usuário"
    : "Organnact - Admin - Novo Usuário";
  const [data, setData] = React.useState({
    loading: true,
    user: {
      id: "",
      name: "",
      email: "",
      created_at: "",
      status: "",
      username: "",
      last_login: "",
      phone: "",
      roles: ["distribuidor"],
      password: "",
      confirmPassword: "",
      gestor: null,
      cnpj: "",
      tipo: "",
    },
    sendPassword: false,
    changePassword: !id,
  });
  const { loading, user, changePassword, sendPassword } = data;
  useEffect(() => {
    _getGestores();
    if (id) {
      loadData();
    } else {
      setData((s) => ({ ...s, loading: false }));
    }
  }, [id]);

  useEffect(() => {
    if (!user.roles.includes("distribuidor")) {
      _updateUser("gestor", null);
      _updateUser("cnpj", "");
    }
  }, [user.roles]);

  async function loadData() {
    let user = await getUserById(id);
    setData({
      loading: false,
      user: {
        ...user,
        name: user.full_name,
        phone: (user.phone || "").replace(/\D/g, ""),
        cnpj: (user.cnpj || "").replace(/\D/g, ""),
        email: (user.email || "").toLowerCase().trim().replace(/['"]/g, ""),
      },
    });
  }

  useEffect(() => {
    if (gestores.length === 0) {
      if (user.gestor) {
      }
    }
  }, [gestores]);

  async function _getGestores() {
    try {
      const users = await getGestores();
      setGestores(users);
    } catch (error) {
      console.error("Error fetching gestores:", error);
      toast.error("Erro ao buscar gestores.");
    }
  }

  function updateField(field, value) {
    setData((s) => ({
      ...s,
      [field]: value,
    }));
  }

  function toggleSendPassword() {
    setData((s) => ({
      ...s,
      sendPassword: !s.sendPassword,
    }));
  }

  function _updateUser(field, value) {
    setData((s) => ({
      ...s,
      user: {
        ...s.user,
        [field]: value,
      },
    }));
  }

  function validate() {
    if (!user.username) {
      toast.error("Por favor, preencha o nome de usuário.");
      return false;
    }
    if (user.username.length < 3) {
      toast.error("O nome de usuário deve ter pelo menos 3 caracteres.");
      return false;
    }
    if (!user.name) {
      toast.error("Por favor, preencha o nome.");
      return false;
    }
    if (user.name.trim().split(" ").length < 2) {
      toast.error("Por favor, preencha o nome completo (nome e sobrenome).");
      return false;
    }
    if (!user.email) {
      toast.error("Por favor, preencha o email.");
      return false;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(user.email)) {
      toast.error("Por favor, preencha um email válido.");
      return false;
    }
    const phoneDigits = unformatPhone(user.phone);
    if (phoneDigits.length > 0 && (phoneDigits.length < 10 || phoneDigits.length > 11)) {
      toast.error("Telefone inválido. Use (XX) XXXXX-XXXX ou (XX) XXXX-XXXX.");
      return false;
    }
    if (!user.roles || user.roles.length === 0) {
      toast.error("Por favor, selecione pelo menos uma função.");
      return false;
    }
    if (user.roles.includes("admin") && !isAdmin) {
      toast.error("Você não tem permissão para atribuir a função de administrador.");
      return false;
    }
    if (user.roles.includes("gestor") && !isAdmin) {
      toast.error("Você não tem permissão para atribuir a função de gestor.");
      return false;
    }
    if (user.roles.includes("distribuidor") && isAdmin) {
      if (!user.gestor) {
        toast.error("Por favor, selecione um gestor para o distribuidor.");
        return false;
      }
      const cnpjDigits = unformatCNPJ(user.cnpj);
      if (!cnpjDigits) {
        toast.error("Por favor, preencha o CNPJ para o distribuidor.");
        return false;
      }
      if (!validateCNPJ(cnpjDigits)) {
        toast.error("CNPJ inválido. Verifique os dígitos.");
        return false;
      }
    }
    if ((user.roles.includes("distribuidor") || user.roles.includes("gestor")) && !user.tipo) {
      toast.error("Por favor, selecione o tipo (PET ou EQUI).");
      return false;
    }
    if (changePassword && !user.password) {
      toast.error("Por favor, preencha a nova senha.");
      return false;
    }
    if (changePassword && user.password.length < 6) {
      toast.error("A senha deve ter pelo menos 6 caracteres.");
      return false;
    }
    if (changePassword && user.password !== user.confirmPassword) {
      toast.error("As senhas não conferem.");
      return false;
    }
    return true;
  }

  async function saveUser() {
    if (!validate()) return;
    const phoneDigits = unformatPhone(user.phone);
    const cnpjDigits = unformatCNPJ(user.cnpj);
    if (id) {
      toast.promise(
        updateUser(
          id,
          user.username,
          user.name,
          user.email,
          phoneDigits,
          user.roles,
          changePassword ? user.password : undefined,
          user.roles.includes("distribuidor") ? user.gestor : undefined,
          cnpjDigits,
          user.roles.includes("admin") ? null : user.tipo || null
        ),
        {
          loading: "Salvando usuário...",
          success: () => {
            navigate("/admin/usuarios");
            return "Usuário atualizado com sucesso!";
          },
          error: (error) => {
            console.error("Error updating user:", error);
            return "Erro ao atualizar usuário.";
          },
        }
      );
    } else {
      toast.promise(
        createUser(
          user.username,
          user.name,
          user.email,
          user.roles,
          phoneDigits,
          user.password,
          user.roles.includes("distribuidor") ? user.gestor : undefined,
          cnpjDigits,
          sendPassword,
          user.roles.includes("admin") ? null : user.tipo || null
        ),
        {
          loading: "Criando usuário...",
          success: () => {
            navigate("/admin/usuarios");
            return "Usuário criado com sucesso!";
          },
          error: (error) => {
            console.error("Error creating user:", error.response?.data?.message);
            return error.response?.data?.message || "Erro ao criar usuário.";
          },
        }
      );
    }
  }

  const gestorValue = useMemo(() => {
    if (user.gestor && gestores.length > 0) {
      const gestor = gestores.find(
        (g) => parseInt(g.id) === parseInt(user.gestor)
      );
      if (gestor) {
        return { value: parseInt(gestor.id), label: gestor.full_name };
      }
    }
    return null;
  }, [user.gestor, gestores]);

  const isDistribuidor = user.roles.includes("distribuidor");

  if (loading) {
    return (
      <S.Container>
        <WhiteBox>
          <Title>Carregando...</Title>
        </WhiteBox>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <BackButton />
      <WhiteBox>
        <Title>Dados do Usuário</Title>
        <Col2Grid style={{ gap: 5 }}>
          <div>
            <Label>Nome de Usuário (Será utilizado para efetuar login)</Label>
            <FH style={{ alignItems: "center", gap: 10 }}>
              <Input
                type="text"
                placeholder="username"
                autoFocus
                autoComplete="off"
                value={user.username}
                onChange={(e) => {
                  let username = e.target.value;
                  username = username.replace(/[^a-zA-Z0-9_]/g, "");
                  username = username.replace(/[\s-]/g, "_");
                  username = username.toLowerCase();
                  if (/^\d/.test(username)) {
                    username = `u${username}`;
                  }
                  _updateUser("username", username);
                }}
              />
            </FH>
          </div>
          <div>
            <Label>Nome Completo</Label>
            <Input
              type="text"
              placeholder="Nome Sobrenome"
              autoComplete="full-name"
              value={user.name}
              onChange={(e) => {
                _updateUser("name", ucwords(e.target.value));
              }}
            />
          </div>
          <div>
            <Label>Email</Label>
            <Input
              type="email"
              placeholder="email@exemplo.com"
              autoComplete="email"
              value={user.email}
              onChange={(e) => _updateUser("email", e.target.value.toLowerCase().trim().replace(/['"]/g, ""))}
            />
          </div>
          <div>
            <Label>Telefone</Label>
            <Input
              type="text"
              placeholder="(41) 99999-9999"
              autoComplete="phone"
              value={formatPhone(user.phone || "")}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, "").slice(0, 11);
                _updateUser("phone", digits);
              }}
            />
          </div>
          {isDistribuidor && (
            <div>
              <Label>CNPJ</Label>
              <Input
                type="text"
                placeholder="00.000.000/0000-00"
                autoComplete="off"
                value={formatCNPJ(user.cnpj || "")}
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, "").slice(0, 14);
                  _updateUser("cnpj", digits);
                }}
              />
            </div>
          )}
          {!user.roles.includes("admin") && (
            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: 6,
                padding: 12,
                display: "flex",
                flexDirection: "column",
                gap: 5,
                height: "auto",
                gridColumn: "span 2",
              }}
            >
              <Label>Tipo (Divisão)</Label>
              <FH style={{ gap: 10 }}>
                <Role
                  id="pet"
                  text="PET"
                  onClick={() => _updateUser("tipo", "pet")}
                  selected={user.tipo === "pet"}
                />
                <Role
                  id="equi"
                  text="EQUI"
                  onClick={() => _updateUser("tipo", "equi")}
                  selected={user.tipo === "equi"}
                />
              </FH>
            </div>
          )}
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: 6,
              padding: 12,
              display: "flex",
              flexDirection: "column",
              gap: 5,
              height: "auto",
              gridColumn: "span 2",
            }}
          >
            <Label>Funções</Label>
            {isAdmin && (
              <>
                <Role
                  id="admin"
                  text="Administrador"
                  onClick={() => _updateUser("roles", ["admin"])}
                  selected={user.roles.includes("admin")}
                />
                <Role
                  id="gestor"
                  text="Gestor"
                  onClick={() => _updateUser("roles", ["gestor"])}
                  selected={user.roles.includes("gestor")}
                />
              </>
            )}
            <Role
              id="distribuidor"
              text="Distribuidor"
              onClick={() => _updateUser("roles", ["distribuidor"])}
              selected={user.roles.includes("distribuidor")}
            />
            {user.roles.includes("distribuidor") && (
              <Select
                noOptionsMessage={() => "Nenhum gestor encontrado"}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#ddd",
                    boxShadow: "none",
                    "&:hover": {
                      borderColor: "#aaa",
                    },
                  }),
                }}
                options={gestores.map((g) => ({
                  value: parseInt(g.id),
                  label: g.full_name,
                }))}
                placeholder="Selecione um gestor"
                isClearable
                value={gestorValue}
                onChange={(selected) => {
                  _updateUser("gestor", selected ? selected.value : null);
                }}
                autoFocus={false}
              />
            )}
          </div>

          <div
            style={{
              gridColumn: "span 2",
            }}
          >
            <hr />
            <Title
              onClick={() =>
                id && updateField("changePassword", !changePassword)
              }
              style={{
                cursor: id ? "pointer" : "default",
                display: "flex",
                alignItems: "center",
                gap: 5,
              }}
            >
              {id && (
                <FontAwesomeIcon
                  icon={data.changePassword ? faCheckCircle : faCircle}
                />
              )}
              {id ? "Alterar senha" : "Definir senha"}
            </Title>
          </div>
          {data.changePassword && (
            <>
              <div>
                <Label>Senha</Label>
                <Input
                  type="password"
                  autoComplete="new-password"
                  placeholder="Mínimo 6 caracteres"
                  value={user.password || ""}
                  onChange={(e) => _updateUser("password", e.target.value)}
                />
              </div>
              <div>
                <Label>Confirme a senha</Label>
                <Input
                  type="password"
                  placeholder="Repita a senha"
                  value={user.confirmPassword || ""}
                  onChange={(e) =>
                    _updateUser("confirmPassword", e.target.value)
                  }
                />
              </div>
              {!id && (
                <FH
                  style={{
                    alignItems: "center",
                    gap: 10,
                    cursor: "pointer",
                    gridColumn: "span 2",
                    marginTop: -15,
                    padding: 0,
                  }}
                  onClick={toggleSendPassword}
                >
                  {sendPassword ? (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{ color: "#4caf50" }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faCircle}
                      style={{ color: "#ccc" }}
                    />
                  )}
                  <Text>
                    Enviar senha por email para o usuário após a criação.
                  </Text>
                </FH>
              )}
            </>
          )}
          <hr style={{ gridColumn: "span 2", margin: "0 0 10px 0" }} />
        </Col2Grid>
        <Button onClick={saveUser}>
          {id ? "Salvar Edição" : "Criar Usuário"}
        </Button>
      </WhiteBox>
    </S.Container>
  );
}

function Role({ id, text = "", onClick, selected }) {
  return (
    <div
      onClick={onClick}
      style={{
        padding: "6px 10px",
        borderRadius: 6,
        backgroundColor: selected ? "#e3f2fd" : "#fafafa",
        border: selected ? "1px solid #3483fa" : "1px solid #eee",
        cursor: "pointer",
        fontSize: 13,
        fontWeight: 500,
        display: "flex",
        alignItems: "center",
        gap: 6,
        color: selected ? "#3483fa" : "#555",
        transition: "all 0.15s",
      }}
    >
      <FontAwesomeIcon icon={selected ? faCheckCircle : faCircle} />
      {text}
    </div>
  );
}

export default Novo;
